const LOCAL = 'http://localhost:4401/api/v1';
const DEV = 'https://wa-arma-dev-pre-dev-gxa3g6d3fwcacefu.westus2-01.azurewebsites.net/api/v1';
const UAT = 'https://wa-arma-dev-akenbma6a6hnb6d5.westus2-01.azurewebsites.net/api/v1';
const PROD = 'https://wa-arma-prod-e9duhqc5b7ajd0g8.westus2-01.azurewebsites.net/api/v1';
const ngrox = 'https://b19f-180-151-230-178.in.ngrok.io/api/v1';

const ENV_URLS = {
    LOCAL,
    DEV,
    UAT,
    PROD,
    NGROK: ngrox
};

const CURRENT_ENV_LABEL = process.env.REACT_APP_ENV?.toUpperCase();
const BASE_URL = process.env.REACT_APP_API_BASE_URL || ENV_URLS[CURRENT_ENV_LABEL];

export default BASE_URL;

// test for CI / CD pipeline
